import React from "react";
import { translations } from "../translations";

const RULE_ICONS = ["🖥️", "🚫", "⚠️", "🛑"];

const PermissionModal = ({ onAccept, onDecline, lang }) => {
  const t = translations[lang];
  const rules = [
    t.permissionModal.rules.fullscreen,
    t.permissionModal.rules.tabSwitch,
    t.permissionModal.rules.refreshClose,
    t.permissionModal.rules.violation,
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal permission-modal">
        <div className="modal-icon-ring">🔒</div>
        <h2 className="modal-title">{t.permissionModal.title}</h2>
        <p className="modal-subtitle">{t.permissionModal.subtitle}</p>
        <p className="modal-instruction">{t.permissionModal.instruction}</p>

        <ul className="rules-list">
          {rules.map((rule, i) => (
            <li key={i} className="rules-list-item">
              <span className="rules-list-icon">{RULE_ICONS[i]}</span>
              <span>{rule}</span>
            </li>
          ))}
        </ul>

        <div className="modal-actions">
          <button type="button" className="btn-primary btn-lg" onClick={onAccept}>
            {t.acceptAndStart}
          </button>
          {onDecline && (
            <button type="button" className="btn-ghost" onClick={onDecline}>
              {t.cancel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PermissionModal;
